import React from 'react';
import ReactDOM from 'react-dom';

import * as _ from 'lodash'
import queryString from 'query-string'
// import scrollToElement from 'scroll-to-element'

import json from '../Data/questions.json'
import Logic from '../Logic'

import App from '../App'

const State = {}


function updateDerived() {
  const result = Logic.getBalance(State.survey, 'chosenAnswer')

  if(State.ui.explore && result === 'ok')
    State.derived.flaggedQuestions = Logic.getQuestionsWithHighestAnswer(State.survey, 'chosenAnswer')

  if(State.ui.explore && (result === 'oob' || result === 'poob')) {
    State.derived.flaggedQuestions = Logic.getNTopQuestionsWithHighestWeightedScore(State.survey, 'chosenAnswer', 5)
  }


}

function update() {
  updateDerived()

  // console.log('state is now', State)
  ReactDOM.render(<App />, document.getElementById('root'));

  // Update hash with state
  window.location.hash = queryString.stringify(State.serialiseState())
}

function addAppStateProperties() {

  State.survey = json
  _.each(State.survey, subsection => {
    _.each(subsection.questions, q => {
        q.chosenAnswer = null           // The currently selected answer
        q.originalChosenAnswer = null   // In explore mode, this is the user's original answer
        q.expanded = false
    })
  })

  // UI
  State.ui = {
    intro: true,
    surveyActiveSection: null,
    explore: false,
    showResultPopup: false,
    showAboutPopup: false
  }

  State.derived = {
    flaggedQuestions: [],
    improvementType: 'none'
  }
}


function expandFirstUnansweredQuestion() {
  _.each(State.survey, section => {
    let found = false
    _.each(section.questions, q => {
      if(found) return

      if(q.chosenAnswer === null) {
        q.expanded = true
        found = true
      }
    })
  })
}

// function expandFirstFlaggedQuestion() {
//   _.each(State.survey, section => {
//     let found = false
//     _.each(section.questions, q => {
//       if(found) return
//
//       let flagged = Logic.questionIsFlagged(section.id, q.id, State.derived.flaggedQuestions)
//       if(flagged) {
//         q.expanded = true
//         found = true
//       }
//     })
//   })
// }
//

State.init = function() {
  addAppStateProperties()


  // Restore answers from url hash
  var hashState = queryString.parse(window.location.hash)
  _.each(hashState, (v, k) => {

    if(_.has(State.ui, k)) {
      v = v === 'true' ? true : v
      v = v === 'false' ? false : v
      v = isNaN(v) ? v : +v
      State.ui[k] = v
      return
    }

    var [sectionId, questionId, answerType] = k.split('+')
    State.survey[sectionId].questions[questionId][answerType === 'o' ? 'originalChosenAnswer' : 'chosenAnswer'] = +v
  })

  // console.log('state', State)

  update()
}

State.action = function(type, params) {
  // console.log('action', type, params)

  State.ui.showAboutPopup = false
  State.ui.showResultPopup = false

  switch(type) {
  case 'getStarted':
    State.ui.intro = false
    expandFirstUnansweredQuestion()
    break

  case 'toggleQuestionExpanded':
    params.question.expanded = !params.question.expanded
    break

  case 'setAnswer':
    const prevBalance = Logic.getBalance(State.survey, 'chosenAnswer')
    // const prevBalanceIsNotOk = prevBalance === 'oob' || prevBalance === 'poob'
    // const originalBalanceIsOk = Logic.getBalance(State.survey, 'originalChosenAnswer') === 'ok'

    let question = State.survey[params.section.id].questions[params.question.id]
    question.chosenAnswer = params.answerIndex

    // Show popup on incremental improvements
    const improvementType = Logic.balanceHasImproved(State.survey, prevBalance)
    // State.ui.showResultPopup = !originalBalanceIsOk && State.ui.explore &&  improvementType !== 'none'
    State.derived.improvementType = improvementType

    if(!State.ui.explore && Logic.allQuestionsAnswered(State.survey, 'chosenAnswer')) {
      // The final questions has been answered!

      _.each(State.survey, section => {
        _.each(section.questions, question => {
          question.originalChosenAnswer = question.chosenAnswer
          // question.chosenAnswer = null
        })
      })

      State.ui.showResultPopup = true
      State.ui.explore = true
      State.ui.surveyActiveSection = null
    }


    if(!State.ui.explore) {
      question.expanded = false
      expandFirstUnansweredQuestion()
    }

    break;

  case 'nextSurveySection':
    State.ui.surveyActiveSection++
    break

  case 'openSurveySection':
    // if(!State.ui.explore)
    //   break
    if(State.ui.surveyActiveSection === params.sectionIndex)
      State.ui.surveyActiveSection = null
    else
      State.ui.surveyActiveSection = params.sectionIndex
    break


  // case 'completeSurvey':
  //   // copy answers to originalChosenAnswer
  //   _.each(State.survey, section => {
  //     _.each(section.questions, question => {
  //       question.originalChosenAnswer = question.chosenAnswer
  //       // question.chosenAnswer = null
  //     })
  //   })
  //
  //   State.ui.showResultPopup = true
  //   State.ui.explore = true
  //   State.ui.surveyActiveSection = null
  //
  //   break;

  case 'showResultPopup':
    State.ui.showResultPopup = true
    break;

  case 'closeResultPopup':
    State.ui.showResultPopup = false
    State.ui.surveyActiveSection = null
    break;

  case 'showAboutPopup':
    State.ui.showAboutPopup = true
    break;

  case 'closeAboutPopup':
    State.ui.showAboutPopup = false
    break;

  default:
    console.log('unknown action', type)
    break;
  }


  // if(State.ui.explore) {
  //   expandFirstFlaggedQuestion()
  // }

  update()

  // if(params && params.sectionElement) {
  //   setTimeout(() => (scrollToElement(params.sectionElement, {offset: -160})), 300)
  // }
}

State.serialiseState = function() {
  let serialisedState = {}

  _.each(State.survey, section => {
    _.each(section.questions, question => {
      if(question.originalChosenAnswer !== null)
        serialisedState[section.id + '+' + question.id + '+o'] = question.originalChosenAnswer

      if(question.chosenAnswer !== null)
        serialisedState[section.id + '+' + question.id + '+c'] = question.chosenAnswer
    })
  })

  _.extend(serialisedState, State.ui)

  return serialisedState
}

export default State;



// WEBPACK FOOTER //
// ./src/State/index.js